<template>
    <div class="qingwu">
        <div class="admin_main_block">
            <div class="admin_main_block_top">
                <div class="admin_main_block_left">
                    <div>照片直播首页添加/编辑</div>
                </div>

                <div class="admin_main_block_right">
                    <div><el-button icon="el-icon-back" @click="$router.go(-1)">返回</el-button></div>
                </div>
            </div>

            <div class="admin_form_main">
                <el-form  label-width="100px" ref="info" :model="info">


                    <el-form-item label="基地" prop="F_IN_JID_ID">
                        <el-select v-model="info.F_IN_JID_ID" placeholder="请选择基地" @change="selectChange()">
                            <el-option label="请选择基地" :value="0"></el-option>
                            <el-option v-for="(v,k) in list['jid']" :label="v.F_VR_JIDMC" :key="k" :value="v.F_IN_ID"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="营期" prop="F_IN_YINGQ_ID">
                        <el-select v-model="info.F_IN_YINGQ_ID" placeholder="请选择营期" @change="selectChange()">
                            <el-option label="请选择营期" :value="0"></el-option>
                            <el-option v-for="(v,k) in list['yingq']" :label="v.F_IN_NAME" :key="k" :value="v.F_IN_ID"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="营期期限" prop="F_IN_YINGQQX_ID">
                        <el-select v-model="info.F_IN_YINGQQX_ID" placeholder="请选择营期期限" @change="selectChange()">
                            <el-option label="请选择营期期限" :value="0"></el-option>
                            <el-option v-for="(v,k) in list['yingqx']" :label="v.F_VR_QISHU" :key="k" :value="v.F_IN_ID"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="班级" prop="F_IN_YINGDBJ_ID">
                        <el-select v-model="info.F_IN_YINGDBJ_ID" placeholder="请选择班级" @change="selectChange()">
                            <el-option label="请选择班级" :value="0"></el-option>
                            <el-option v-for="(v,k) in list['banj']" :label="v.F_VR_BANJMC" :key="k" :value="v.F_IN_ID"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="视频简介" prop="F_VR_SHIPJJ" :rules="[{required:true,message:'视频简介不能为空',trigger: 'blur' }]"><el-input placeholder="请输入视频简介" v-model="info.F_VR_SHIPJJ"></el-input></el-form-item>
                    <el-form-item label="班级简介" prop="F_VR_BANJJJ" :rules="[{required:true,message:'班级简介不能为空',trigger: 'blur' }]"><el-input type="textarea" placeholder="请输入班级简介" maxlength="200" show-word-limit v-model="info.F_VR_BANJJJ"></el-input></el-form-item>


                    <el-form-item label="封面" prop="thumb"><el-upload class="avatar-uploader" :action="$api.advUpload" :headers="upload_headers" :show-file-list="false" :on-success="handleAvatarSuccess" >
                        <img v-if="info.F_VR_FENHGM" :src="info.F_VR_FENHGM" class="avatar-upload">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload></el-form-item>


                    <el-form-item label="上传视频">
                        <el-upload
                                :on-success="handleVodUploadSuccess"
                                :on-remove="handleVodRemove"
                                :before-remove="beforeVodRemove"
                                :on-exceed="handleUploadExceed"
                                :file-list="fileList"
                                :action="$api.shipUpload"
                                :headers="upload_headers"
                                :limit="1"
                                class="upload-demo">
                            <el-button size="small" type="primary">上传视频</el-button>
                            <el-tooltip placement="right-end">
                                <div slot="content">最大支持1G，<br>
                                    支持3GP、ASF、AVI、DAT、DV、FLV、F4V、<br>
                                    GIF、M2T、M4V、MJ2、MJPEG、MKV、MOV、MP4、<br>
                                    MPE、MPG、MPEG、MTS、OGG、QT、RM、RMVB、<br>
                                    SWF、TS、VOB、WMV、WEBM 等视频格式上传</div>
                                <i class="el-icon-question"/>
                            </el-tooltip>
                        </el-upload>
                    </el-form-item>


                    <!--<el-form-item label="视频" prop="thumb"><el-upload class="avatar-uploader" :action="$api.advUpload" :headers="upload_headers" :show-file-list="false" :on-success="handleAvatarSuccesses" >
                        <img v-if="info.F_VR_SHIP" :src="info.F_VR_SHIP" class="avatar-upload">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload></el-form-item>-->

                    <el-form-item>
                        <el-button type="primary" @click="submitForm('info')">提交</el-button>
                        <!-- <el-button @click="resetForm('info')">重置</el-button> -->
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
      return {
          edit_id:0,
          info:{
          },
          list:[],
          upload_headers:{},
          fileList: [],//上传文件列表
          video: {// 课时对象
              title: '',
              sort: 0,
              free: false,
              videoSourceId: '',
              videoOriginalName: ''
          },
      };
    },
    watch: {},
    computed: {},
    methods: {
        resetForm:function(e){
            this.$refs[e].resetFields();
        },
        submitForm:function(e){
            let _this = this;

            // 验证表单
            this.$refs[e].validate(function(res){
                if(res){
                    //  判断是Add 或者 Edit
                    let url = _this.$api.addZhaopzbsy;
                    if(_this.edit_id>0){
                        url = _this.$api.editZhaopzbsy+_this.edit_id;
                    }
                    // Http 请求
                    _this.$post(url,_this.info).then(function(res){
                        if(res.code == 200){
                            _this.$message.success("编辑成功");
                            _this.$router.go(-1);
                        }else{
                            _this.$message.error("编辑失败");
                        }
                    });
                }
            });
        },
        get_adv_info:function(){
            let _this = this;
            this.$get(this.$api.editZhaopzbsy+this.edit_id).then(function(res){
                _this.info = res.data.zhaopzbsy;
                _this.list = res.data;
                _this.info.F_VR_SHIP = res.data.zhaopzbsy.F_VR_SHIP;
            })

        },
        get_adv_list:function(){
            let _this = this;
            this.$get(this.$api.addZhaopzbsy).then(function(res){
                _this.list = res.data;
            })

        },
        selectChange:function(){
            this.$forceUpdate();
        },
        handleAvatarSuccess(res) {
            this.info.F_VR_FENHGM = res.data;
            this.$forceUpdate();
        },
        handleAvatarSuccesses(res) {
            this.info.F_VR_SHIP = res.data;
            this.$forceUpdate();
        },






        //成功回调
        handleVodUploadSuccess(response, file, fileList) {
            this.video.videoSourceId = response.data.videoId
            this.video.videoOriginalName = file.name;
            this.info.F_VR_SHIP = response.data;
            console.log(this.info.F_VR_FENHGM)
            console.log(response)
            console.log(response.data.videoId)
            console.log(file.name)

        },
//修改回掉
        editVideo(videoId) {
            this.dialogVideoFormVisible = true
            video.getVideoInfoById(videoId).then(response => {
                this.video = response.data.item
                this.fileList = [{'name': this.video.videoOriginalName}]
            })
        },
//视图上传多于一个视频
        handleUploadExceed(files, fileList) {
            this.$message.warning('想要重新上传视频，请先删除已上传的视频')
        },

        beforeVodRemove(file, fileList) {
            return this.$confirm(`确定移除 ${file.name}？`)
        },
        handleVodRemove(file, fileList) {
            console.log(file)
            vod.removeById(this.video.videoSourceId).then(response=>{
                this.$message({
                    type: 'success',
                    message: response.message
                })
            })
        },
        handleVodRemove(file, fileList) {
            console.log(file)
            vod.removeById(this.video.videoSourceId).then(response => {
                this.video.videoSourceId = ''
                this.video.videoOriginalName = ''
                this.fileList = []
                this.$message({
                    type: 'success',
                    message: response.message
                })
            })
        },







    },
    created() {
        this.upload_headers.Authorization = 'Bearer '+localStorage.getItem('token'); // 要保证取到

        if(!this.$isEmpty(this.$route.params.adv_position_id)){
            this.info.ap_id = this.$route.params.adv_position_id;
        }

        // 判断是否是编辑
        if(!this.$isEmpty(this.$route.params.id)){
            this.edit_id = this.$route.params.id;
        }

        if(this.edit_id>0){
            this.get_adv_info();
        }else{
            this.get_adv_list();
        }
        
    },
    mounted() {}
};
</script>
<style lang="scss" scoped>
.line{text-align: center}
</style>